module.exports = __webpack_public_path__ + "img/productBgImg14.dbee29fe.png";